<template>
  <div>
    <svg
        :width="iconSize"
        :height="iconSize"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
      <path
          d="M12.5 2C6.97892 2.0044 2.5044 6.47892 2.5 12V18.6664C2.50581 20.5051 3.99494 21.9942 5.83363 22H9.16637V13.6659H5.00022V12C4.99934 7.85796 8.35629 4.49952 12.4983 4.49855C16.6404 4.49767 19.9988 7.85462 19.9998 11.9967V13.6668H15.8327V22H19.1664C21.0051 21.9942 22.4942 20.5051 22.5 18.6664V12C22.4956 6.47892 18.0211 2.0044 12.5 2Z"
          :fill="color"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconSvgSnmmiPodcast',
  props: {
    color: {
      type: String,
      default: '#000000',
    },
    size: {
      type: Number,
      default: null,
    },
  },
  computed: {
    iconSize() {
      return this.size ? `${this.size}px` : '44px'
    },
  },
}
</script>

<style scoped></style>